import { render, staticRenderFns } from "./benchmark_points_standard.vue?vue&type=template&id=0edd2352&scoped=true"
import script from "./benchmark_points_standard.vue?vue&type=script&lang=js"
export * from "./benchmark_points_standard.vue?vue&type=script&lang=js"
import style0 from "./benchmark_points_standard.vue?vue&type=style&index=0&id=0edd2352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd2352",
  null
  
)

export default component.exports